/**
 * PrivacyContainer
 * --
 */
import React from 'react';
import PrivacyPresenter from './PrivacyPresenter';
import { useParams } from 'react-router-dom';
import { useGetProvisions } from 'hooks/ProvisionHooks';
import { useGetSetting } from 'hooks/SettingHooks';

const PrivacyContainer = (props) => {
  /* ===== ROUTE ===== */
  const { policyType } = useParams() ?? 'privacy';

  /* ===== PROPS ===== */
  const { screenSize } = props;

  /* ===== Data ===== */
  const { data: Provision } = useGetProvisions(null, {
    select: (res) => {
      const { status, data } = res;
      if (status !== 200) return [];

      return data;
    },
    initialData: [],
  });
  const { data: Setting } = useGetSetting(1, null, {
    select: (res) => {
      const { status, data } = res;
      if (status !== 200) return null;

      return {
        rental_setting: data.rental_setting,
        parcel_service_setting: data.parcel_service_setting,
      };
    },
    initialData: {
      rental_setting: { policy: '-' },
      parcel_service_setting: { policy: '-' },
    },
  });

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /**
   * 약관 데이터 정제
   * --
   */
  const ProvisionData = React.useMemo(() => {
    if (!Provision.length) return;

    // 정기배송, 렌탈 정책 정제
    const parcelRentalPolicy = [
      {
        provision_title: '렌탈 서비스 정책',
        provision_content: Setting?.rental_setting?.policy,
        provision_type: 'RENTAL',
      },
      {
        provision_title: '정기배송 서비스 정책',
        provision_content: Setting?.parcel_service_setting?.policy,
        provision_type: 'SUBSCRIPTION',
      },
    ];

    const policies = [...parcelRentalPolicy, ...Provision];
    const findData = policies.find(
      (policy) => policy.provision_type === policyType.toLocaleUpperCase()
    );

    return findData;
  }, [policyType, Provision, Setting]);

  /* ===== RENDER ===== */
  return (
    <>
      <PrivacyPresenter data={ProvisionData} screenSize={screenSize} />
    </>
  );
};

export default PrivacyContainer;
